export const media = {
  tablet: 890,
  mobile: 600
};
